export class StudentGradingScaleModel {
	gpa: number;
	is_passing: boolean;
	letter_grade: string;
	percentage_high: number | null;
	percentage_low: number | null;
	variations: unknown[];
	description: string | null;
}
